import { createFileRoute } from '@tanstack/react-router';
import { checkSecurityDomain } from '../utils/auth';
import AdminPanel from '../components/admin/AdminPanel';
import { motion } from 'framer-motion';
import { AnalyticsThemeProvider, categoryAccent } from '@repo/ui/theme';
import { useIsMobile } from '../hooks/useIsMobile';

export const Route = createFileRoute('/admin')({
  component: RouteComponent,
  beforeLoad: checkSecurityDomain({ routeObject: 'admin' }),
});

function RouteComponent() {
  const isMobile = useIsMobile();
  return (
    <AnalyticsThemeProvider accent={categoryAccent['session-performance']}>
      <motion.div
        className={`p-4 ${isMobile ? 'pt-6' : 'pt-10'}`}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <AdminPanel />
      </motion.div>
    </AnalyticsThemeProvider>
  );
}
